// src/utils/api.js

import axios from 'axios';

const baseURL = process.env.VUE_APP_BASE_URL;

export const fetchUsers = async (param='customer') => {
    try {
        const response = await axios.get(`${baseURL}?action=readUser&type=${param}&platform=report`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch users');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchReportList = async (param='admin') => {
    try {
        const response = await axios.get(`${baseURL}?action=readReportList&type=${param}&platform=report`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch report list');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchReportTypes = async () => {
    try {
        const response = await axios.get(`${baseURL}?action=getReportTypes`);
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch report types');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const addReportType = async (typeName) => {
    try {
        const response = await axios.post(`${baseURL}?action=addReportType`, { type_name: typeName });
        if (response && response.data && response.data.status === 'success') {
            return response.data;
        } else {
            throw new Error(response.data.message || 'Failed to add report type');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchReportListWithFilters = async (filters) => {
    try {
        console.log(filters, 'filters');
        const selectedTypes = filters.reportTypes && filters.reportTypes.length > 0
            ? filters.reportTypes.map(t => t.type_name).join(',')
            : '';
        const apiFilters = {
            start_date: filters.startDate || '',
            end_date: filters.endDate || '',
            report_type: selectedTypes,
            code_remark: filters.codeRemark || ''
        };
        console.log(apiFilters, 'apiFilters');
        const response = await axios.post(`${baseURL}?action=readReportWithFilters`, apiFilters);
        console.log(response, 'response');
        if (response && response.data && response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error(response.data.message || 'Failed to fetch filtered reports');
        }
    } catch (error) {
        throw new Error('Network Error: ' + (error.message || error));
    }
};

export const fetchSupplierList = async () => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_BASE_URL}?action=readSupplier`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier list:', error);
      throw error;
    }
  };
  
  export const fetchSupplierTypes = async () => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_BASE_URL}?action=getSupplierTypes`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier types:', error);
      throw error;
    }
  };
  
  export const fetchSupplierListWithFilters = async (filters) => {
    try {
      console.log(filters, 'filters');
      
      // Transform the property names to match what the API expects
      const apiFilters = {
        start_date: filters.startDate || '',
        end_date: filters.endDate || '',
        supplier_type: Array.isArray(filters.supplierType) 
          ? filters.supplierType.map(t => t.type_name || t).join(',') 
          : (filters.supplierType || ''),
        code_remark: filters.codeRemark || ''
      };
      
      console.log(apiFilters, 'apiFilters');
      
      const response = await axios.post(`${process.env.VUE_APP_BASE_URL}?action=readSupplierWithFilters`, apiFilters);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier list with filters:', error);
      throw error;
    }
  };

  export const createSupplier = async (supplierData) => {
    try {
      const response = await axios.post(`${process.env.VUE_APP_BASE_URL}?action=createSupplier&type=supplier`, supplierData);
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error);
      throw error;
    }
  };
  
  export const updateSupplier = async (supplierData) => {
    try {
      const response = await axios.post(`${process.env.VUE_APP_BASE_URL}?action=updateSupplierDetail&type=supplierList`, supplierData);
      return response.data;
    } catch (error) {
      console.error('Error updating supplier:', error);
      throw error;
    }
  };
  
  export const deleteSupplier = async (id) => {
    try {
      const response = await axios.post(`${process.env.VUE_APP_BASE_URL}?action=deleteSupplier&type=supplierList`, { id });
      return response.data;
    } catch (error) {
      console.error('Error deleting supplier:', error);
      throw error;
    }
  };

  export const resetUserPassword = async (userId, newPassword) => {
    try {
      const response = await axios.post(`${process.env.VUE_APP_BASE_URL}?action=resetPassword&type=user&platform=report`, {
        id: userId,
        newPassword: newPassword
      });
      return response.data;
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error;
    }
  };